'use client'

import dynamic from 'next/dynamic'
// Type-only import — value imports here would eagerly evaluate PdfViewer.tsx
// (and its pdfjs side effects) on the server, defeating ssr:false and
// throwing "Object.defineProperty called on non-object" during SSR.
import type { PdfViewerProps } from './PdfViewer'

const DynamicPdfViewer = dynamic(() => import('./PdfViewer'), {
  ssr: false,
})

export function PdfViewerClient(props: PdfViewerProps) {
  return <DynamicPdfViewer {...props} />
}
